<template>
  <div class="PapelSegurancaConsumo">
    <b-modal visible
             size="md"
             centered
             no-close-on-backdrop
             no-close-on-esc
             hide-footer
             hide-header>
      <div class="row">
        <div class="col">
          <h5>
            Escolha um dos papéis que não foram utilizados:
          </h5>
          <!-- <h5 v-if="origemConsumo == 'selo'">
            Escolha um dos papéis para cada custa:
          </h5> -->
          <small class="text-info">Caso o papel desejado não se encontre na lista abaixo, é possível digitá-lo.</small>
          <!-- <h6 v-if="origemConsumo == 'registro' && !!propOrdemServico" 
              class="text-danger"> 
            Nenhum impresso de segurança relacionado a este ato foi encontrado, por favor selecione o tipo de impresso:
          </h6> -->
        </div>
      </div>

      <!-- Componente padrão de consumo -->
      <div v-if="mostrarOpcoesDeCusta && !!propOrdemServico"
           class="row mt-2">
        <div class="col ">
          <div v-for="custa in custas" 
               :key="`papel_seguranca_consumo_custa_${ custa.index }_${ _uid }`"
               class="mb-4">
            <span><b>Custa (Ato):</b> {{ custa.item.custa.ato }} </span><br>
            <label for="impresso">Selecione o tipo de impresso</label>
            <v-select id="impresso"
                      :options="tipos_de_impressos.length && tipos_de_impressos"
                      taggable
                      label="tipo_impressoTeste"
                      class="PapelSegurancaConsumo--vSelect"
                      :class="{'PapelSegurancaConsumo--vSelectError': error.show}"
                      name="tipos_de_impressos"
                      @input="tipoDeImpressoSelecionado($event, custa)">
              <template #no-options="{ search, searching, loading }">
                <small class="text-danger"
                       style="text-transform: lowercase">
                  <span style="text-transform: uppercase">N</span>ão há nenhum Tipo de Impresso disponível para uso.
                </small>
              </template>
            </v-select>
            <span v-if="error.show">
              <small class="text-danger">
                {{ showTextError() }}
              </small>
            </span>
            
            <!-- select do número do lote -->
            <label class="mt-2 mb-0"
                   for="lote">Selecione o número do lote</label><br>
            <v-select :id="custa.index"
                      :value="custa.papelSeguranca.length ? exibirNumeroLotesSelecionado(custa) : ''"
                      :options="computedPapeisDisponiveis"
                      taggable
                      label="numero_serie"
                      class="PapelSegurancaConsumo--vSelect mt-2"
                      :class="{'PapelSegurancaConsumo--vSelectError': error.show}"
                      name="papel_seguranca"
                      :disabled="!custa.check_impresso"
                      @input="selecionarLote($event, custa)">
              <template #no-options="{ search, searching, loading }">
                <small class="text-danger"
                       style="text-transform: lowercase">
                  <span style="text-transform: uppercase">N</span>ão há nenhum papel de segurança disponível para uso, verifique o cadastro de lotes.
                </small>
              </template>
            </v-select>
            <span v-if="error.show"> 
              <small class="text-danger"> 
                {{ showTextError() }}
              </small>
            </span>
          </div>
        </div>
      </div> 
      <!-- Utilizado apenas para consumi direto da tela de impresão de registro -->
      <div v-if="origemConsumo == 'registro' && !propOrdemServico"
           class="row mt-2">
        <div class="col">
          <v-select v-model="item"
                    :options="itens_disponiveis"
                    taggable
                    label="numero_serie"
                    class="PapelSegurancaConsumo--vSelect"
                    :class="{'PapelSegurancaConsumo--vSelectError': error.show}"
                    name="papel_seguranca"
                    @input="changePapelSelectedRegistro()">
            <template #no-options="{ search, searching, loading }">
              <small class="text-danger"
                     style="text-transform: lowercase">
                <span style="text-transform: uppercase">N</span>ão há nenhum papel de segurança disponível para uso, verifique o cadastro de lotes.
              </small>
            </template>
          </v-select>
          <span v-if="error.show">
            <small class="text-danger">
              {{ showTextError() }}
            </small>
          </span>
        </div>
      </div>
              
      <div class="row">
        <div class="col text-right">
          <hr class="hr-secondary">
          <button class="btn btn-sm btn-default"
                  @click="voltar()">
            Voltar
          </button>
          <button class="btn btn-sm btn-secondary ml-1"
                  :disabled="!validate()"
                  @click="consumirPapel()">
            Continuar
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* services */
  import PapelSegurancaLoteItensService from "@/services/PapelSeguranca/PapelSegurancaLoteItensService"
  import PapelSegurancaLoteService from "@/services/PapelSeguranca/PapelSegurancaLoteService"
  import CartorioConfigService from '@/services/CartorioConfigService'
  import { tipoImpressoToAlerta } from '@/utils/impressoDeSeguranca'
  import { includes } from 'lodash'

  export default {
    name: "PapelSegurancaConsumo",
    props: {
      propRegistroId: {
        type: Number,
        default: () => null
      },
      propSelo: {
        type: Object,
        default: () => ({})
      },
      propCustas: {
        type: Array,
        default: () => ([])
      },
      propTipoPapel: {
        type: String,
        default: 'papel_de_seguranca_registro_civil'
      },
      propOrdemServico: {
        type: Boolean,
        default: () => false
      },
    },
    data () {
      return {
        origemConsumo: 'registro',
        item: null,
        itens_disponiveis: [],
        custas: [],
        error: {
          show: false,
          text: null
        },
        tipos_de_impressos: null,
        item_tipos_de_impresso: null,
        arrayTiposDeImpressos: [],
        arrayPapeis: [],
        papeisSelecionados: [],
        mostrarOpcoesDeCusta: false,
        habilitarBotao: false,
        numerosDosLotesSelecionados: [],
        tiposDeImpressosSelecionados: [],
      }
    },
    computed: {
      computedPapeisDisponiveis () {
        const papeis =  this.arrayPapeis.filter(item => !this.papeisSelecionados.includes(item.numero_serie))
        return papeis
      },
    },
    async created () {
      await this.getTiposImpressos()
      await this.init()
    },
    methods: {
      async init () {
        try {
          this.papeisSelecionados = []
          this.custas = [ ...this.propCustas ] 
          loader({ active: true, text: 'Carregando papéis disponíveis...' })
          this.itens_disponiveis = []
          this.mostrarOpcoesDeCusta = true
          const numAlerta = await this.getNumAlerta(this.propTipoPapel)
            
          const {data, total} = await PapelSegurancaLoteItensService.getItensAtivos(this.propTipoPapel)
          this.itens_disponiveis = data

          if (numAlerta && total <= numAlerta) {
            await displayMessage('error', 'Atenção!', `Impresso de Segurança acabando. Verifique seus Lotes.`)
          }
        } catch (e) {
          const message = e.response && e.response.data && e.response.data.message || 'Não foi possível listar os impressos de segurança.'
          await displayMessage('error', 'Atenção!', message)
        } finally {
          loader({ active: false })
        }
      },
      async consumirPapel () { // O fluxo de consumo para registros e O.S foi extraido, seguir fluxo de cadastro ou edição
        loader({ active: true, text: '' })
        if (this.origemConsumo == 'registro' && !!this.propRegistroId) {
          return await this.consumirPapelDeImpressao()
        }
        this.$emit('onHide', this.custas)

        loader({ active: false, text: '' })
        
      },
      async consumirPapelDeImpressao () { // Apenas utilizado para consumir papeis diretamente da tela de impressão
        try {
          // consumimos o papel
          loader({ active: true, text: 'Consumindo papel...' })
          this.item.tipo_papel = this.propTipoPapel
          const response = await PapelSegurancaLoteItensService.consume(this.item, this.propSelo, this.propRegistroId, this.reimprimir, this.propTipoPapel)

          objSwal.success.title = 'Papel consumido'
          objSwal.success.text = `Papel ${this.item.numero_serie.toUpperCase()} foi consumido.`
          Swal.fire(objSwal.success)
          this.item = null
          this.$emit('onHide', response.item)
          
        } catch (e) {
          if (e.response.data.message) {
            this.error.show = true
            this.error.text = e.response.data.message
          } else {
            objSwal.error.title = 'Erro ao consumir papel.'
            objSwal.error.text = 'Tente novamente, caso o error persistir contate o suporte.'
            Swal.fire(objSwal.error)
          }
        } finally {
          this.reimprimir = false

          this.init(false)
          loader({ active: false, text: '' })
        }
      },
      changePapelSelected (event, custa, index) {
        //Sempre zera os papeis para evitar que seja adicionado mais que a quantidade de custas
        if (event === null) return custa.papelSeguranca = []
        custa.papelSeguranca = []

        const totalPapeis = this.itens_disponiveis[index].data.length
        const totalCustas = custa.item.quantidade
        let indexSelecionado = this.itens_disponiveis[index].data.findIndex(i => i.numero_serie === event.numero_serie)

        // Verifica se há papeis sucientes de acordo o index do papel selecionado e a quantidade de custas criadas
        const verificaDisponibilidade = (totalPapeis - indexSelecionado) >= totalCustas ? true : false
        if (verificaDisponibilidade) {
          for (let i = 1; i <= totalCustas; i++) {
            custa.papelSeguranca.push(this.itens_disponiveis[index].data[indexSelecionado])
            indexSelecionado++
          }
        } else {
          displayMessage('error', 'Erro', `Não há papéis suficientes, após o selecionado, para o número de custas criadas | Total de Custas ${totalCustas}`)
          this.this.habilitarBotao = false
        }

        this.error.show = false
        this.error.text = null
        this.reimprimir = false
        if (!!this.propOrdemServico) {
          if (event.numero_serie) {
            this.habilitarBotao = true
            return
          }
          this.habilitarBotao = false
        }
      },
      changePapelSelectedRegistro (event) {
        this.error.show = false
        this.error.text = null
        this.reimprimir = false
        if (!!this.propOrdemServico) {
          if (event.numero_serie) {
            this.habilitarBotao = true
            return
          }
          this.habilitarBotao = false
        }
      },
      validate () {  
        if (this.propCustas.length) {
          let qtPapeis = 0
          let qtPapeisSelecionados = this.papeisSelecionados.length

          for (const custa of this.propCustas) qtPapeis += custa.quantidade   
 
          const validate = qtPapeis === qtPapeisSelecionados ? true : false
          return validate
        }
        if (this.item?.numero_serie) return true
     
      },
      voltar () {
        this.custas = this.custas.map(custa => {
          if (custa && !!custa.papelSeguranca) {
            custa.papelSeguranca = null
          }
          return custa
        })

        this.$emit('onHide', this.custas)
      },
      showTextError () {
        if (this.error.text === 'Número de série já utilizado') {
          /**
           * Utilizamos a opção reimprimir para informar ao back que desejamos
           * reutilizar um papel de segurança que já foi utilizado pelo registro
           * que estamos imprimindo
           */

          this.reimprimir = true

          return `${this.error.text}. Clique em continuar caso queira reimprimir.`
        } else {
          return `${this.error.text}. Escolha um papel novo.`
        }
      },
      async getNumAlerta (chave) {
        try {
          if (chave) {
            const config = await CartorioConfigService.showByChave({chave: tipoImpressoToAlerta(chave)})
            if (config) return parseInt(config.valor, 10)
          }
        } catch (error) {
          let message
          if (error.response) {
            message = getErrors(error.response)
          } else {
            message = getErrors(error)
          }

          displayMessage('error', 'Erro!', message.message)
        }
      },
      async getTiposImpressos () {
        this.tiposImpressos = await PapelSegurancaLoteService.listTipos()
        let selosCustasImpressos = [...this.tiposImpressos.tipos_de_papeis, ...this.tiposImpressos.tipos_de_selos]
        this.tipos_de_impressos = selosCustasImpressos.map(obj => obj.label)
      },
      getTiposImpressosByCodigoCusta (custa) {
        let selosCustasImpressos = [...this.tiposImpressos.tipos_de_papeis, ...this.tiposImpressos.tipos_de_selos]
        let impresso = selosCustasImpressos.find(impresso => impresso.codigosAtos.includes(custa.item.custa.codigo))
        if (!impresso) {
          impresso = selosCustasImpressos.find(impresso => impresso.value === custa.item.custa.tipo_impresso_seguranca_personalizado)
        }
        return impresso
      },
      getCustaOptions (custa) {
        let selectedOptions = []
        this.custas.forEach(item => {
          item.papelSeguranca.forEach(papel => selectedOptions.push(papel.papel_seguranca_lote_item_id))
        })
        // const selectedOptions = this.custas.map(custa => custa.papelSeguranca && custa.papelSeguranca.papel_seguranca_lote_item_id)
        const options = this.itens_disponiveis.find(item => item.value === custa.tipoImpresso.value)
        return options && options.data && options.data.filter(item => !selectedOptions.includes(item.papel_seguranca_lote_item_id))
      },
      async tipoDeImpressoSelecionado (event, custa) {
       


        if (!event) {
          this.removeItemFromSelecionados(custa)
          custa.check_impresso = false
        }
        if (event) {
          this.item_tipos_de_impresso = event
          custa.check_impresso = true
          this.tiposDeImpressosSelecionados.push(event)
        }
        this.$emit('atualizarAto', event, custa)
        // if (!event) {
        //   custa.check_impresso = false
        //   this.habilitarBotao = false
        // }
        
        // Verificando se o campo de Impresso está vazio.
        let selosCustasImpressos = [...this.tiposImpressos.tipos_de_papeis, ...this.tiposImpressos.tipos_de_selos]
        const impressoSelecionado = selosCustasImpressos.filter(obj => obj.label === event)

        const papel = impressoSelecionado.length ? impressoSelecionado[0].value : null
    
        //Fazendo requisição para buscar os papéis dos Tipos de Impressos
        const resultadoDaRequisicao = await PapelSegurancaLoteItensService.getItensAtivos(papel)
        this.itens_disponiveis = await resultadoDaRequisicao.data.map(obj => obj)
        this.arrayPapeis =  this.itens_disponiveis
        
        // Função para não repetir os números dos lotes
        this.arraySemLoteEscolhido()   
      },
      selecionarLote (event, custa) {  
        if (event) {
          custa.papelSeguranca = []
          const totalPapeis = this.arrayPapeis.length
          const totalCustas = custa.item.quantidade
          let indexSelecionado = this.arrayPapeis.findIndex(i => i.numero_serie === event.numero_serie)
          const verificaDisponibilidade = (totalPapeis - indexSelecionado) >= totalCustas ? true : false
          if (verificaDisponibilidade) {
            for (let i = 1; i <= totalCustas; i++) {
              custa.papelSeguranca.push(this.itens_disponiveis[indexSelecionado])
              this.papeisSelecionados.push(this.itens_disponiveis[indexSelecionado].numero_serie)
              custa.check_impresso = false
              indexSelecionado++
            }
          } else {
            displayMessage('error', 'Erro', `Não há papéis suficientes, após o selecionado, para o número de custas criadas | Total de Custas ${totalCustas}`)
            this.this.habilitarBotao = false
          }
        }
        else {
          this.papeisSelecionados = this.papeisSelecionados.filter(obj1 => custa.papelSeguranca.some(obj2 => obj2.numero_serie === obj1.numero_serie))
          custa.papelSeguranca = []
        }
       

        // this.numerosDosLotesSelecionados.push(event.numero_serie)
        if (this.custas.length > 1) {
          if (event && this.custas[this.custas.length - 1].index == custa.index) { 
            this.habilitarBotao = true

          } else {
            this.habilitarBotao = false
          }
          return
        }

        if (event) { 
          this.habilitarBotao = true
          return
        }
        this.habilitarBotao = false
      },
      arraySemLoteEscolhido () {
        this.arrayPapeis = this.arrayPapeis.filter(lote => {
          if (!this.numerosDosLotesSelecionados.includes(lote.numero_serie)) return true
          
          return false
        })
      },
      removeItemFromSelecionados (custa) {
        const papeis = custa.papelSeguranca
        for (const papel of papeis) {
          this.papeisSelecionados = this.papeisSelecionados.filter(item => item !== papel.numero_serie)
        }
        custa.papelSeguranca = [] // reinicia papeis da custas
      },
      exibirNumeroLotesSelecionado (custa) {
        const papeis = custa.papelSeguranca
        let text = ''
        // Percorre o array e concatena numero de série
        for (let i = 0; i < papeis.length; i++) {
          text += papeis[i].numero_serie

          // Adiciona uma vírgula, exceto no último item
          if (i < papeis.length - 1) {
            text += ',   '
          }
        }
        return text
      }
    }
  }
</script>

<style lang="scss"> 
 .PapelSegurancaConsumo {
   &--vSelect, &--vSelect input {
     text-transform: uppercase;
    }

   &--vSelectError {
     border-color: red;
   }

   &--vSelectError .vs__selected {
     color: red !important;
   }
 }
</style>
